import Firebase from "firebase";
import VueCookies from "vue-cookies";

const state = {
  contas: null,
  isSuccess: false
};

const mutations = {
  setContas: (state, payload) => {
    state.contas = payload;
  },
  setIsSuccess: (state, payload) => {
    state.isSuccess = payload;
  }
};

const actions = {
  getContasInFirestore: async ({ commit }) => {
    let _associacao = VueCookies.get("IDASSOCIACAO");
    let response = [];

    await Firebase.firestore()
      .collection("contas")
      .where("_associacao", "==", _associacao)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(function(doc) {
          response.push(doc.data());
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
    commit("setContas", response);
  },

  addContaInFirestore: async (context, conta) => {
    await Firebase.firestore()
      .collection("contas")
      .doc(conta._id)
      .set(conta)
      .then(() => {
        context.commit("setIsSuccess", true);
        context.dispatch("getContasInFirestore");
      }).catch(() => {
        context.commit("setIsSuccess", false);
    });
  },

  updateContaInFirestore: async (context, conta) => {
    await Firebase.firestore()
      .collection("contas")
      .doc(conta._id)
      .update(conta)
      .then(() => {
        context.commit("setIsSuccess", true);
      }).catch(() => {
        context.commit("setIsSuccess", false);
    });
  },
};

const getters = {
  getContas: state => state.contas,
  getIsSuccess: state => state.isSuccess
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
